// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2cxyO","rootSuccess":"CompleteLink_rootSuccess__2uX08","rootFailure":"CompleteLink_rootFailure__2GSt4","isDisabled":"CompleteLink_isDisabled__2__WJ"};